import { EarningsInsight } from '@api';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { EarningsInsightIcon } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import { DateCell, DateCellProps } from './DateCell';
import styles from './DateCellWithEarningsInsight.module.scss';

interface DateCellWithEarningsInsightProps extends DateCellProps {
  earningsInsight?: EarningsInsight;
  isFetching: boolean;
}

export const DateCellWithEarningsInsight = ({
  earningsInsight,
  isFetching,
  ...rest
}: DateCellWithEarningsInsightProps) => {
  const { params } = useQueryParams();
  const entityTag = params[queryKeys.assetOverviewAsset];

  return (
    <div className={styles.root}>
      <DateCell {...rest} />
      {isFetching ? (
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '28px',
                height: '28px',
                borderRadius: '8px',
              },
            },
          ]}
        />
      ) : (
        !!earningsInsight &&
        entityTag && (
          <EarningsInsightIcon
            entityTag={entityTag}
            size={28}
            earningsInsight={earningsInsight}
            source={POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW}
          />
        )
      )}
    </div>
  );
};
